import type { TOC } from '@ember/component/template-only'
import { t, formatDate } from 'ember-intl'
import formatValue from 'teacher-ui-client/helpers/format-value'
import colspanMax from 'teacher-ui-client/modifiers/colspan-max'
import type { ReportData } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/student/events/report-loader'
import { ThStandard } from 'teacher-ui-client/components/th/standard'

interface Signature {
  Element: HTMLTableElement
  Args: {
    events: ReportData['events']
    isReloading?: boolean
  }
}

export const Report: TOC<Signature> = <template>
  <table class="divide-oceany-blue-150 border-oceany-blue-150 divide-y border-b" ...attributes>
    <thead>
      <tr>
        <ThStandard class="w-40 min-w-40">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.date"}}
        </ThStandard>
        <ThStandard class="w-1/2">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.bookChapter"}}
        </ThStandard>
        <ThStandard class="w-1/2">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.score"}}
        </ThStandard>
      </tr>
    </thead>
    <tbody class="divide-oceany-blue-150 divide-y {{if @isReloading 'opacity-50'}}">
      {{#each @events as |event index|}}
        <tr data-test-table-row={{index}}>
          <td data-test-cell="created_at" class="p-3">{{formatDate
              event.created_at
              day="2-digit"
              month="short"
              year="numeric"
            }}</td>
          <td data-test-cell="title" class="p-3">
            {{event.title}}
          </td>
          <td data-test-cell="score" class="p-3">{{formatValue event.score append=" / 5"}}</td>
        </tr>
      {{else}}
        <tr>
          <td data-test-empty-message class="p-3 text-center italic" {{colspanMax}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.eventsEmptyMessage"}}
          </td>
        </tr>
      {{/each}}
    </tbody>
  </table>
</template>
